import { render, staticRenderFns } from "./GrantApplicationCard.vue?vue&type=template&id=873e038c&"
import script from "./GrantApplicationCard.vue?vue&type=script&lang=js&"
export * from "./GrantApplicationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports